import { mmFetchWithResponse } from './mmFetchWithResponse';

class InventoryAdjustmentApi {
    constructor() {
        this.baseUrl = 'api/inventory-adjustment/v1';
    }

    async getHistoricalBulkShrinkRequests(facilityId, startDate, endDate) {
        const url = `${this.baseUrl}/bulkShrink/historical?facilityId=${facilityId}&startDate=${startDate}&endDate=${endDate}`;
        return mmFetchWithResponse(url);
    }

    async createBulkShrink(data) {
        const url = `${this.baseUrl}/bulkShrink/create`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
            },
        });
    }

    async getPendingBulkShrinkRequests(facilityId) {
        const url = `${this.baseUrl}/bulkShrink/pending?facilityId=${facilityId}`;
        return mmFetchWithResponse(url);
    }

    async updatePendingBulkShrinkRequest(id, key, value) {
        const url = `${this.baseUrl}/bulkShrink/update/${id}`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({ [key]: value }),
        });
    }

    async approveBulkShrinkRequests(ids) {
        const idsParam = Array.isArray(ids) ? ids : [ids];
        const url = `${this.baseUrl}/bulkShrink/approve`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({ ids: idsParam }),
        });
    }

    async rejectBulkShrinkRequests(ids) {
        const idsParam = Array.isArray(ids) ? ids : [ids];
        const url = `${this.baseUrl}/bulkShrink/reject`;
        return mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({ ids: idsParam }),
        });
    }

    async getItemsForFacilityWeekYear(facilityId, week, year) {
        const url = `${this.baseUrl}/bulkShrink/items/${facilityId}?week=${week}&year=${year}`;
        return mmFetchWithResponse(url);
    }

    async resolveUnitDiscrepancyWithMagnitudeAdjustment(cycleCountEventId, unitAdjustment, reason, palletId) {
        const url = `${this.baseUrl}/cycle-count/unit-discrepancy`;
        return mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ cycleCountEventId, unitAdjustment, reason, palletId }),
        });
    }

    async getBulkShrinkItemsForShipment({ facilityId, shipmentID }) {
        const url = `${this.baseUrl}/bulkShrink/items/${facilityId}/shipment/${shipmentID}`;
        return mmFetchWithResponse(url);
    }
}

export { InventoryAdjustmentApi };
